export enum OpportunityPackageType {
  STRAIGHTCOMMISSION = 'Straight Commission',
  ATRISK = 'At Risk',
  PAIDAPPRAISAL = 'Paid Appraisal'
}
